export const getBreadcrumbsQuery = (lang = 'en') => `
{
  findBreadcrumbsSingleton {
    data {
      onHome {
        ${lang}
      }
      surveysPage {
        ${lang}
      }
      onDashboard{
      ${lang}
      }
    }
  }
}
`
